<template>
  <div :class="type" class="refresh-component">
    <div class="top-display">
      <slot></slot>
    </div>
    <button :class="{grey:btnGrey(type)}" @click="$bus.refresh(type)" class="button-refresh">
      <p class="button-refresh-text">{{currentBtnText}}</p>
      <p class="gem" v-show="!$bus.isDone(type)">{{currentRefreshCost}}</p>
    </button>
    <div class="limit-display" v-show="showHint(type)">{{currentLimitTxt}}</div>
  </div>
</template>
<script>
  import { mapState } from '@/utils/assist'
  export default {
    name: 'Refresh',
    data() {
      return {}
    },
    props: {
      type: String,
    },
    computed: {
      ...mapState(['transify', 'refreshable', 'drawing', 'refreshing']),
      currentLimitTxt() {
        let { timesFree, times, limitsFree, limits } = this.$bus.curRefreshTarget(this.type)
        if (limitsFree - timesFree > 0) {
          // 必须先显示 免费
          if (limitsFree >= 2) return `${limitsFree - timesFree}/${limitsFree}`
        } else {
          // 再显示 付费
          if (limits > -1 && limits >= 2) return `${limits - times}/${limits}`
        }
      },
      currentBtnText() {
        if (this.$bus.isDone(this.type)) {
          return this.transify['CHANGE_DONE']
        } else {
          return this.transify[
            this.type === 'discount' ? 'CHANGE_TRY_YOUR_LUCK' : 'CHANGE_POOL_REFRESH'
          ]
        }
      },
      currentRefreshCost() {
        if (this.$bus.isFree(this.type)) {
          return this.transify['CHANGE_FREE']
        } else if (!this.$bus.isDone(this.type)) {
          return this.$bus.curRefreshTarget(this.type).cost
        } else {
          return ''
        }
      },
    },
    methods: {
      btnGrey(type) {
        return this.$bus.isDone(type) || !this.refreshable || this.drawing || this.refreshing
      },
      showHint(type) {
        return !(this.$bus.isDone(type) || !this.refreshable)
      }
    },
  }
</script>
<style lang="scss">
  // 刷新模块
  .refresh-component {
    position: absolute;
    @include px2res(bottom, 151);
    @include px2res(padding-top, 103);
    @include px2res(padding-left, 31);
    @include px2res(width, 270);
    @include px2res(height, 385);
    z-index: 20;
    &.pool {
      right: 0;
    }
    &.discount {
      left: 0;
      @include px2res(padding-left, 42);
    }
    .top-display {
      position: relative;
      @include px2res(width, 199);
      @include px2res(height, 150);
    }
    .button-refresh {
      @include px2res(margin-top, 10);
      @include px2res(width, 199);
      @include px2res(height, 76);
      color: #8e3c01;
      &.grey {
        color: #5e2d01;
        .button-refresh-text,
        .gem {
          filter: grayscale(1);
        }
      }
      .gem {
        @include px2res(font-size, 26);
      }
    }
    .button-refresh-text {
      line-height: 1.3;
      @include px2res(font-size, 32);
      @include one-line;
    }
    .limit-display {
      @include px2res(margin-top, 8);
      @include px2res(width, 199);
      @include px2res(font-size, 30);
      font-family: $teko-font-family;
      color: #e0f1ff;
      text-align: center;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/refresh/refresh.vue